// extracted by mini-css-extract-plugin
export default {"main":"Message_main__YNxMz","heart":"Message_heart__kook9","heartBeat":"Message_heartBeat__68BkO"};